import type { JSX } from 'react';

type SubtitleIconProps = {
  className?: string;
  variant: 'default' | 'white';
};

const SubtitleIcon = (props: SubtitleIconProps): JSX.Element => {
  const { className, variant } = props;
  switch (variant) {
    case 'white':
      return (
        <svg
          className={className || ''}
          width="20"
          height="19"
          viewBox="0 0 20 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.1998 1.29932C18.1899 1.29932 18.991 2.1236 18.991 3.13106L18.9986 16.2546C18.9991 17.15 17.913 17.5947 17.2854 16.9561L15.3997 15.0374H2.79857C1.80848 15.0374 0.99841 14.2131 0.99841 13.2056V3.13106C0.99841 2.1236 1.80848 1.29932 2.79857 1.29932H17.1998Z"
            stroke="white"
            strokeWidth="1.2"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.2892 9.83174C16.795 9.83174 17.2051 9.42169 17.2051 8.91587C17.2051 8.41005 16.795 8 16.2892 8H12.7205C12.2146 8 11.8046 8.41005 11.8046 8.91587C11.8046 9.42169 12.2146 9.83174 12.7205 9.83174H16.2892Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.2892 12.5769C16.795 12.5769 17.2051 12.1668 17.2051 11.661C17.2051 11.1552 16.795 10.7451 16.2892 10.7451H14.5206C14.0148 10.7451 13.6048 11.1552 13.6048 11.661C13.6048 12.1668 14.0148 12.5769 14.5206 12.5769H16.2892Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.7882 12.5769C12.2941 12.5769 12.7041 12.1668 12.7041 11.661C12.7041 11.1552 12.2941 10.7451 11.7882 10.7451H7.31942C6.81359 10.7451 6.40354 11.1552 6.40354 11.661C6.40354 12.1668 6.81359 12.5769 7.31942 12.5769H11.7882Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.58999 12.5769C5.09581 12.5769 5.50586 12.1668 5.50586 11.661C5.50586 11.1552 5.09581 10.7451 4.58999 10.7451H3.72149C3.21567 10.7451 2.80562 11.1552 2.80562 11.661C2.80562 12.1668 3.21567 12.5769 3.72149 12.5769H4.58999Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.98745 9.83174C10.4933 9.83174 10.9033 9.42169 10.9033 8.91587C10.9033 8.41005 10.4933 8 9.98745 8H3.71847C3.21265 8 2.8026 8.41005 2.8026 8.91587C2.8026 9.42169 3.21265 9.83174 3.71848 9.83174H9.98745Z"
            fill="white"
          />
        </svg>
      );
    case 'default':
    default:
      return (
        <svg className={className || ''} viewBox="-2 -2 28 26" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.01566 0.862305C1.76393 0.862305 0.751176 1.90441 0.751176 3.17809L0.741211 20.4161C0.740694 21.3115 1.82684 21.7562 2.45444 21.1176L5.29152 18.2307H21.2226C22.4743 18.2307 23.4984 17.1886 23.4984 15.9149V3.17809C23.4984 1.90441 22.4743 0.862305 21.2226 0.862305H3.01566ZM4.01566 12.4413C3.46337 12.4413 3.01566 11.9936 3.01566 11.4413V11.1255C3.01566 10.5732 3.46337 10.1255 4.01566 10.1255H8.84325C9.39553 10.1255 9.84325 10.5732 9.84325 11.1255V11.4413C9.84325 11.9936 9.39553 12.4413 8.84325 12.4413H4.01566ZM4.01566 15.9149C3.46337 15.9149 3.01566 15.4672 3.01566 14.9149V14.5991C3.01566 14.0468 3.46337 13.5991 4.01566 13.5991H6.56738C7.11967 13.5991 7.56738 14.0468 7.56738 14.5991V14.9149C7.56738 15.4672 7.11967 15.9149 6.56738 15.9149H4.01566ZM9.70531 15.9149C9.15303 15.9149 8.70531 15.4672 8.70531 14.9149V14.5991C8.70531 14.0468 9.15303 13.5991 9.70531 13.5991H15.6708C16.2231 13.5991 16.6708 14.0468 16.6708 14.5991V14.9149C16.6708 15.4672 16.2231 15.9149 15.6708 15.9149H9.70531ZM18.8088 15.9149C18.2565 15.9149 17.8088 15.4672 17.8088 14.9149V14.5991C17.8088 14.0468 18.2565 13.5991 18.8088 13.5991H20.2226C20.7748 13.5991 21.2226 14.0468 21.2226 14.5991V14.9149C21.2226 15.4672 20.7748 15.9149 20.2226 15.9149H18.8088ZM11.9812 12.4413C11.4289 12.4413 10.9812 11.9936 10.9812 11.4413V11.1255C10.9812 10.5732 11.4289 10.1255 11.9812 10.1255H20.2226C20.7748 10.1255 21.2226 10.5732 21.2226 11.1255V11.4413C21.2226 11.9936 20.7748 12.4413 20.2226 12.4413H11.9812Z"
            fill="currentColor"
          />
        </svg>
      );
  }
};
export default SubtitleIcon;
